import { FC } from 'react';

import LanguageInitializeProvider from 'providers/LanguageInitializeProvider';
import { UsersnapProvider } from 'components/UsersnapProvider/UsersnapProvider';
import Notification from 'components/Notification';
import SentryProvider from 'components/SentryProvider/SentryProvider';
import SearchPopupProvider from 'components/SearchPopup/SearchPopupProvider';
import NativeAppUrlListener from 'routes/NativeAppUrlListener';
import NativeStatusBarProvider from 'components/NativeStatusBarProvider';
import NativePushNotificationsProvider from 'components/NativePushNotificationsProvider';
import NativeAppUpdateProvider from 'components/NativeAppUpdateProvider';

const GlobalComponentsProvider: FC = () => {
  return (
    <>
      <NativeAppUpdateProvider />
      <NativeAppUrlListener />
      <NativeStatusBarProvider />
      <NativePushNotificationsProvider />
      <SentryProvider />
      <UsersnapProvider />
      <Notification />
      <LanguageInitializeProvider />
      <SearchPopupProvider />
    </>
  );
};

export default GlobalComponentsProvider;
